export default function() {
    return {
        visible: false,
        scrollThreshold: 0,

        init() {
            this.scrollThreshold = window.innerHeight;

			window.addEventListener('scroll', this.checkScrollPosition.bind(this));
            window.addEventListener('resize', () => {
                this.scrollThreshold = window.innerHeight;
                this.checkScrollPosition();
            });
			this.checkScrollPosition();

            this.$cleanup = () => {
                window.removeEventListener('scroll', this.checkScrollPosition.bind(this));
                window.removeEventListener('resize', () => {
                    this.scrollThreshold = window.innerHeight;
                    this.checkScrollPosition();
                });
            };
        },

        // Vérifier la position de défilement et mettre à jour la visibilité
        checkScrollPosition() {
            requestAnimationFrame(() => {
                const scrollY = window.scrollY || window.pageYOffset;
                this.visible = scrollY >= this.scrollThreshold;
            });
        },

        // Fonction pour remonter en haut de la page
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };
}
